import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import { useCustWhOptionsQuery } from "hooks/useQueryHook";
import { useState } from "react";
import { SelectField } from "ui-components/Form";

import { FormTitle, Text, DatePickerField } from "ui-components/Form";

function StockHoldInfo({ formRender, control, errors, customerCode, setValue, mode = "ADD" }) {
  const [warehouseCodeOptions, setWarehouseCodeOptions] = useState([]);

  useCustWhOptionsQuery({
    customerCode,
    onSuccess: (data) => {
      setWarehouseCodeOptions(data.data.data);
      if (data.data.data)
      setValue("warehouseCode", data.data.data[0]);
    },
  });

  function renderFn(property, index, length) {
    const { xs, disabled, edit, ...data } = property;
    //custom xs
    const xs2 = xs ? xs : 12 / length;
    const fieldProps = {
      ...data,
      control,
      errors,
      ...(disabled && { disabled }),
      ...(mode === "EDIT" && edit === true && { disabled: true, type: "text" }),
    };

    let renderField;
    if (fieldProps.type === "text" || fieldProps.type === "number") {
      renderField = <Text field={fieldProps} />;
    } else if (fieldProps.type === "date") {
      renderField = <DatePickerField field={fieldProps} />;
    } else if (fieldProps.type === "select") {
      renderField = (
        <SelectField
          field={fieldProps}
          options={
            (fieldProps.name === "warehouseCode" && warehouseCodeOptions)
          }
          control={control}
          errors={errors}
        />
      );
    }
    return (
      <Grid key={index} item xs={xs2}>
        {renderField}
      </Grid>
    );
  }

  return (
    <MDBox>
      <FormTitle title={mode === "EDIT" ? "Stock Unhold" : "Add Stock Hold"} />
      <MDBox mt={1.625}>
        {formRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((row, index) => renderFn(row, index, rows.length))}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default StockHoldInfo;
